module.exports = __webpack_public_path__ + "media/images/flags/CX-09321eea015f933b0a414a9ff6400fc5.svg";